import React, { Component } from "react";
import {
  profile,
  alert,
  total,
  toFixed,
  format_date,
  GET,
  POST,
  loading,
  MonthPicker,
  Select,
  Pagination,
  Navbar,
} from "../../components/CustomComponent.js";
import Dropdown from "react-bootstrap/Dropdown";
export default class CommissionAgent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loaded: false,
      count: 10,
      data_agent: [],

      expandedRow: null,

      // ค่าเริ่มต้นเป็นเดือนปัจจุบัน (Reset ก็กลับมาเดือนปัจจุบันเช่นกัน)
      filter_date: format_date(new Date(), "yyyy-mm", "en"),
      filter_agent_id: "",
      filter_currency: "THB",
      recalc_uid: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await Promise.all([this.GetMaster(), this.Get(0)]);
  }
  // ตัวเลือกของ dropdown ทั้งหน้า ไม่เปลี่ยนระหว่างอยู่บนหน้านี้ ดึงครั้งเดียวตอนเปิดหน้า
  // ไม่ยุ่งกับ loading เพราะ Get เป็นคนคุมสถานะโหลดของตาราง
  GetMaster = async () => {
    let data_agent;
    let [result_agent] = await Promise.all([
      GET("v1/admin/agents", { page_size: 100000, page: 0, data_search: "" }),
    ]);
    if (result_agent?.status) {
      data_agent = result_agent.data.map((e) => ({
        value: e.uid,
        label: e.name_en,
      }));
    }
    this.setState({ data_agent });
  };
  Get = async (page) => {
    const { filter_date, filter_agent_id, filter_currency } = this.state;
    let data, count;
    let _date = new Date(filter_date);
    let _date_start = format_date(
      new Date(_date.getFullYear(), _date.getMonth(), 15),
      "yyyy-MM-dd",
      "en"
    );
    let _date_end = format_date(
      new Date(_date.getFullYear(), _date.getMonth() + 1, 14),
      "yyyy-MM-dd",
      "en"
    );
    loading(true);
    let [result] = await Promise.all([
      GET("profits/monthly-commission", {
        page_size: 10,
        page: page,
        start_date: filter_date
          ? format_date(_date_start, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_date ? format_date(_date_end, "yyyy-mm-dd", "en") : "",
        currency: filter_currency,
      }),
    ]);
    if (result?.status) {
      data = result.data.filter(
        (e) => !filter_agent_id || e.agent.uid === filter_agent_id
      );
      count = result.count;
    }

    this.setState({ data, loaded: true, count });
    loading(false);
  };
  GetByID = async (uid) => {
    const { data, expandedRow } = this.state;
    if (expandedRow === uid) {
      this.setState({ expandedRow: null });
      return;
    }
    loading(true);
    let [result] = await Promise.all([
      GET("profits/monthly-commission-child-agent", { commission_uid: uid }),
    ]);
    if (result?.status) {
      let index = data.findIndex((e) => e.uid === uid);
      data[index].child = result.data;
      this.setState({ data, expandedRow: uid });
    }

    loading(false);
  };
  Update = async () => {
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Are you sure you want to update this item?",
        "confirm",
        "cancel"
      )
    ) {
      loading(true);
      const { data } = this.state;

      // UPDATE LOGIC HERE

      let result = await POST(`profits/payment`, {
        type: "commission-agent",
        uid_list: data.filter((e) => e.checked).map((e) => e.uid),
      });
      if (result?.status) {
        alert("", "success");
        this.Get(0);
      }
      loading(false);
    }
  };
  Recalculate = async (item) => {
    if (
      await alert(
        "",
        "info",
        "Recalculate",
        `Recalculate ${item.month}/${item.year} for ${item.agent?.name_en || "agent"}?`,
        "confirm",
        "cancel"
      )
    ) {
      this.setState({ recalc_uid: item.uid });
      loading(true);
      const result = await POST("v1/admin/profits/monthly-commission/recalc", {
        uid: item.uid,
      });
      if (result?.status) {
        alert("", "success", "Success", "Commission totals have been recalculated.");
        this.Get(0);
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
      this.setState({ recalc_uid: "" });
    }
  };
  // -------------------------------------------------------------------------
  // Render helpers (presentation only — Get / GetByID / Update / Recalculate
  // are unchanged)
  // -------------------------------------------------------------------------
  renderCheck = (checked, onChange, extra = {}) => (
    <label className="pr-check" onClick={(e) => e.stopPropagation()}>
      <input type="checkbox" checked={!!checked} onChange={onChange} {...extra} />
      <span />
    </label>
  );
  render() {
    const {
      filter_date,
      filter_agent_id,
      filter_currency,
      data,
      loaded,
      count,
      data_agent,
      expandedRow,
      recalc_uid,
    } = this.state;
    const rows = Array.isArray(data) ? data : [];
    const isSuper = profile.user_type === "super_user";
    const colCount = isSuper ? 11 : 10;
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ];
    const monthShort = (m) =>
      Number(m) >= 1 && Number(m) <= 12 ? monthNames[Number(m) - 1].slice(0, 3) : m;
    const selectedDate = filter_date ? new Date(filter_date) : null;
    const heroMonth =
      selectedDate && !isNaN(selectedDate)
        ? monthNames[selectedDate.getMonth()].slice(0, 3).toUpperCase()
        : "ALL";
    const heroYear =
      selectedDate && !isNaN(selectedDate) ? selectedDate.getFullYear() : "";
    const currency = global.currency?.find((c) => c.currency_code === filter_currency);
    const selectedAgentLabel = data_agent?.find((a) => a.value === filter_agent_id)?.label;
    const selectable = rows.filter(
      (item) => item.status_payment !== "success" && item.currency === filter_currency
    );
    const checkedRows = rows.filter((e) => e.checked);
    const paidCount = rows.filter((e) => e.status_payment === "success").length;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          {/* ===== Hero ===== */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Commission</div>
                <div className="ar-title">Commission Reports</div>
                <div className="ar-subtitle">
                  Agent commission tracking and payment. Each period runs from the
                  15th at 00:00:00 of the previous month to the 14th at 23:59:59 of
                  this month.
                </div>
              </div>
              <div className="ar-hero-actions">
                <button
                  className="ar-btn-ghost commission-agents.read"
                  onClick={async () => {
                    this.setState({
                      export_date: format_date(new Date(), "yyyy-mm", "en"),
                      modal_excel: true,
                    });
                  }}
                >
                  <span className="icon me-2">{""}</span>Export CSV
                </button>
              <div className="text-end">
                <div className="ar-year">
                  {heroMonth}
                  {heroYear ? <span className="ar-year-small"> {heroYear}</span> : null}
                </div>
                <div className="ar-year-caption">
                  {selectedAgentLabel && (
                    <span className="ar-caption-chip ms-2">{selectedAgentLabel}</span>
                  )}
                </div>
              </div>
              </div>
            </div>

            <div className="ar-toolbar ar-filter mt-3">
<div className="ar-filter-head">
<span className="ar-toolbar-label"><span className="icon me-2">{""}</span>Filter</span>
</div>
<div className="ar-filter-row">
<div className="ar-filter-field">
<span className="ar-filter-label">Month</span>
<MonthPicker
                    className="form-control"
                    placeholder="Month..."
                    onChange={(e) => {
                      this.setState({ filter_date: e });
                    }}
                    value={filter_date}
                  />
</div>
<div className="ar-filter-field">
<span className="ar-filter-label">Agent</span>
<Select
                    className="form-control"
                    placeholder="All agents"
                    options={data_agent}
                    onChange={(e) => {
                      this.setState({ filter_agent_id: e });
                    }}
                    value={filter_agent_id}
                  />
</div>
<div className="ar-toolbar-actions">
                <button className="ar-btn-gold" onClick={() => this.Get(1)}>
                  <span className="icon me-2">{""}</span>Search
                </button>
                <button
                  className="ar-btn-ghost"
                  onClick={() =>
                    this.setState(
                      {
                        filter_date: format_date(new Date(), "yyyy-mm", "en"),
                        filter_agent_id: "",
                        filter_currency: "THB",
                      },
                      () => this.Get(1)
                    )
                  }
                >
                  Reset
                </button>
              </div>
</div>
<div className="ar-filter-foot">
<div className="d-flex align-items-center gap-2">
                  {global.currency?.map((item) => (
                    <button
                      key={item.currency_code}
                      className={`ar-pill ${
                        item.currency_code === filter_currency ? "active" : ""
                      }`}
                      onClick={() => {
                        this.setState({ filter_currency: item.currency_code });
                        setTimeout(() => {
                          this.Get(1);
                        }, 100);
                      }}
                    >
                      {item.image}
                      <span className="ms-1">{item.currency_code}</span>
                    </button>
                  ))}
                </div>
</div>
</div>
          </div>

          {/* ===== Table ===== */}
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{""}</span>
                  Agent Commission
                </div>
                <div className="ar-table-caption">
                  {heroMonth} {heroYear} · {filter_currency} ·{" "}
                  {selectedAgentLabel ? selectedAgentLabel : "All agents"} ·{" "}
                  {rows.length} period{rows.length === 1 ? "" : "s"} · {paidCount} paid
                </div>
              </div>
              <div className="d-none d-md-flex align-items-center gap-3 ar-legend">
                <span>
                  <span className="pu-legend-dot on" />
                  Paid
                </span>
                <span>
                  <span className="pu-legend-dot off" />
                  Unpaid
                </span>
                <span className="ar-toolbar-hint text-secondary">
                  Click a row to see the broker breakdown
                </span>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover text-nowrap ar-table pu-table">
                <thead>
                  <tr>
                    <td className="text-center wpx-60 commission-agents.update">
                      <div className="pu-th-check">
                        {this.renderCheck(
                          selectable.length > 0 && selectable.every((item) => item.checked),
                          (e) => {
                            const checked = e.target.checked;
                            const newData = data.map((item) => {
                              if (
                                item.status_payment !== "success" &&
                                item.currency === filter_currency
                              ) {
                                return { ...item, checked };
                              }
                              return item;
                            });
                            this.setState({ data: newData });
                          },
                          { title: "Select all unpaid" }
                        )}
                        <span>All</span>
                      </div>
                    </td>
                    <td className="text-nowrap ar-sticky">Agent</td>
                    <td className="text-nowrap text-center">Year</td>
                    <td className="text-nowrap text-center">Month</td>
                    <td className="text-nowrap text-center">Start Date</td>
                    <td className="text-nowrap text-center">End Date</td>
                    <td className="text-nowrap text-center">Currency</td>
                    <td className="text-nowrap text-end ar-group-start">Amount ({filter_currency})</td>
                    <td className="text-nowrap text-end ar-head-profit">Commission ({filter_currency})</td>
                    <td className="text-nowrap text-center">Paid</td>
                    {isSuper && <td className="text-nowrap text-center td-actions">Actions</td>}
                  </tr>
                </thead>
                <tbody>
                  {rows.map((item, index) => {
                    const expanded = expandedRow === item.uid;
                    const agentName = item.agent?.name_en || "";
                    const toggle = () => this.GetByID(item.uid);
                    return (
                      <React.Fragment key={item.uid || `array-${index}`}>
                        <tr className={`pu-row-toggle ${expanded ? "expanded" : ""} ${item.checked ? "checked" : ""}`}>
                          <td data-label="Select" className="text-center commission-agents.update">
                            {item.status_payment !== "success" &&
                              this.renderCheck(item.checked, (e) => {
                                let _data = [...data];
                                _data[index].checked = e.target.checked;
                                this.setState({ data: _data });
                              })}
                          </td>
                          <td data-label="Agent" className="ar-sticky pointer" onClick={toggle}>
                            <div className="pu-user">
                              <span className={`pu-chevron icon ${expanded ? "open" : ""}`}>{""}</span>
                              <div className="pu-avatar">
                                {(agentName || "?").trim().charAt(0).toUpperCase()}
                              </div>
                              <div className="min-w-0">
                                <div className="pu-name text-truncate" title={agentName}>
                                  {agentName || "-"}
                                </div>
                                <div className="pu-sub">
                                  <span className="icon me-1">{""}</span>
                                  {item.agent?.brokers || 0} broker{Number(item.agent?.brokers) === 1 ? "" : "s"}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td data-label="Year" className="text-center ar-muted pointer" onClick={toggle}>
                            {item.year}
                          </td>
                          <td data-label="Month" className="text-center pointer" onClick={toggle}>
                            <div className="ar-month-badge justify-content-center">
                              <span>{monthShort(item.month)}</span>
                            </div>
                          </td>
                          <td data-label="Start Date" className="text-center ar-muted pointer" onClick={toggle}>
                            {item.start_date ? format_date(item.start_date, "dd/mm/yyyy hh:mm", "th") : ""}
                          </td>
                          <td data-label="End Date" className="text-center ar-muted pointer" onClick={toggle}>
                            {item.end_date ? format_date(item.end_date, "dd/mm/yyyy hh:mm", "th") : ""}
                          </td>
                          <td data-label="Currency" className="text-center pointer" onClick={toggle}>
                            <span className="pu-code">{item.currency}</span>
                          </td>
                          <td data-label={`Amount (${filter_currency})`} className="text-end ar-group-start">
                            {item.total_amount ? toFixed(item.total_amount, 2) : "00.00"}
                          </td>
                          <td data-label={`Commission (${filter_currency})`} className="text-end pu-commission pointer" onClick={toggle}>
                            {toFixed(item.total_commission, 2)}
                          </td>
                          <td data-label="Paid" className="text-center pointer" onClick={toggle}>
                            <span className={`pr-status ${item.status_payment === "success" ? "on" : "off"}`}>
                              {item.status_payment === "success" ? "Paid" : "Unpaid"}
                            </span>
                          </td>
                          {isSuper && (
                            <td data-label="Actions" className="text-center td-actions">
                              <Dropdown align="end">
                                <Dropdown.Toggle className="pu-action-toggle" id={`commission-agent-actions-${index}`}>Action</Dropdown.Toggle>
                                <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                                  <Dropdown.Item
                                    className={`pu-action-item commission-agents.update ${recalc_uid === item.uid ? "opacity-50 pe-none" : ""}`}
                                    onClick={() => this.Recalculate(item)}
                                  >
                                    <span className="icon">{""}</span>Recalculate
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                          )}
                        </tr>

                        {/* แถวรายละเอียด broker ของ agent */}
                        {expanded &&
                          (item.child?.length ? (
                            item.child.map((childItem, childIndex) => (
                              <tr key={`child-${item.uid}-${childIndex}`} className="pu-child-row">
                                <td className="commission-agents.update d-none d-md-table-cell"></td>
                                <td data-label="Broker Name" className="ar-sticky">
                                  <div className="pu-child-name">
                                    <span className="pu-child-line" />
                                    <span className="icon me-2">{""}</span>
                                    {childItem.name_en}
                                  </div>
                                </td>
                                <td className="d-none d-md-table-cell" colSpan={5}></td>
                                <td data-label={`Amount (${filter_currency})`} className="text-end ar-group-start">
                                  {toFixed(childItem.total_amount, 2)}
                                </td>
                                <td data-label={`Commission (${filter_currency})`} className="text-end pu-commission">
                                  {toFixed(childItem.total_commission, 2)}
                                </td>
                                <td className="d-none d-md-table-cell"></td>
                                {isSuper && <td className="d-none d-md-table-cell td-actions"></td>}
                              </tr>
                            ))
                          ) : (
                            <tr className="pu-child-row">
                              <td className="commission-agents.update d-none d-md-table-cell"></td>
                              <td colSpan={colCount - 1} className="pu-none">
                                No broker detail for this period
                              </td>
                            </tr>
                          ))}
                      </React.Fragment>
                    );
                  })}
                  {loaded && rows.length === 0 && (
                    <tr>
                      <td colSpan={colCount} className="text-center py-5">
                        <div className="ar-empty">
                          <span className="icon d-block mb-2">{""}</span>
                          No commission for {heroMonth} {heroYear} · {filter_currency}
                          {selectedAgentLabel ? ` · ${selectedAgentLabel}` : ""}
                        </div>
                      </td>
                    </tr>
                  )}
                  {rows.length > 0 && (
                    <tr className="ar-total">
                      <td className="commission-agents.update"></td>
                      <td className="ar-sticky">
                        <div className="ar-month-badge">
                          <span className="ar-month-badge-total">Σ</span>
                          TOTAL
                        </div>
                      </td>
                      <td colSpan={5}></td>
                      <td data-label={`Amount (${filter_currency})`} className="text-end ar-group-start">
                        {toFixed(total(rows, "total_amount"), 2)}
                      </td>
                      <td data-label={`Commission (${filter_currency})`} className="text-end">
                        {toFixed(total(rows, "total_commission"), 2)}
                      </td>
                      <td></td>
                      {isSuper && <td className="td-actions"></td>}
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {checkedRows.length > 0 && (
              <div className="pu-confirm-bar">
                <div className="pu-confirm-info">
                  <b>{checkedRows.length}</b> period{checkedRows.length === 1 ? "" : "s"} selected ·
                  commission <b>{toFixed(total(checkedRows, "total_commission"), 2)}</b> {filter_currency}
                </div>
                <button className="ar-btn-gold commission-agents.update" onClick={this.Update}>
                  <span className="icon me-2">{""}</span>Confirm payment
                </button>
              </div>
            )}
          </div>

          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-3">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>
      </div>
    );
  }
}
